export default __webpack_public_path__ + "static/media/Generalscan.fb62ec73.png";